export const RESET_DOCUMENTS = 'DEALERS/ADMIN_CONFIG/RESET_DOCUMENTS';

export const UPLOAD_DOCUMENT = 'DEALERS/ADMIN_CONFIG/UPLOAD_DOCUMENT/REQUEST';
export const UPLOAD_DOCUMENT_SUCCESS = 'DEALERS/ADMIN_CONFIG/UPLOAD_DOCUMENT/SUCCESS';
export const UPLOAD_DOCUMENT_FAILURE = 'DEALERS/ADMIN_CONFIG/UPLOAD_DOCUMENT/FAILURE';

export const REMOVE_DOCUMENT = 'DEALERS/ADMIN_CONFIG/REMOVE_DOCUMENT';
